import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production'
  ? '/api'
  : 'http://localhost:5000/api');

export const createApiInstance = (token) => {
  const instance = axios.create({ 
    baseURL: API_URL,
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json'
    }
  });
  
  if (token) {
    instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }
  
  return instance;
};

export const handleApiError = (error, setError = null, setUser = null) => {
  console.error('Erro na API:', error.response?.data || error.message);

  if (error.response?.status === 401) {
    localStorage.removeItem('googleToken');
    localStorage.removeItem('localToken');
    localStorage.removeItem('googlePicture');
    if (setUser) setUser(null);
    if (setError) {
      setError('Sua sessão expirou. Por favor, faça login novamente.');
      return Promise.reject(error);
    }
  }

  const message = error.response?.data?.error || error.message || 'Erro na requisição';
  if (setError) setError(message);

  return Promise.reject(error);
};
